'use strict';

var protocol = require('../util/protocol');

module.exports = {
    /**
     * 拍照或从手机相册中选取图片<br />
     * 推荐使用 hysdk.selectImage，<strong>该 API 将会被废弃 </strong><br/>
     * 对应native接口：chooseImage
     * @method hysdk.chooseImage
     * @category Image
     * @example ./chooseImage.js[1-40]
     * @description
     *
     * <table style="text-align:center">
     *     <tr>
     *         <th colspan="2">参数</th>
     *         <th>类型</th>
     *         <th>说明</th>
     *         <th>iOS</th>
     *         <th>Android</th>
     *         <th>touch</th>
     *         <th>wechat</th>
     *     </tr>
     *     <tr>
     *         <td colspan="2">sizeType</td>
     *         <td>string array</td>
     *         <td>指定原图还是压缩图，默认二者都有</td>
     *         <td rowspan="2">X</td>
     *         <td rowspan="2">X</td>
     *         <td rowspan="2">X</td>
     *         <td rowspan="2">√</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">sourceType</td>
     *         <td>string array</td>
     *         <td>指定来源是相册还是相机，默认二者都有</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">localIds</td>
     *         <td>string array</td>
     *         <td>上次已经选择过的图片<br/>从15年10月iOS新架构发布以后<br/>由于iOS公共相册组件存在bug，iOS暂时不支持使用</td>
     *         <td>X</td>
     *         <td>√</td>
     *         <td>X</td>
     *         <td>√</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">resType</td>
     *         <td>string</td>
     *         <td>转化协议，协议转化成 //imghy + imgurl，值为'remote'，必传，否则在 Android 高版本无法加载图片</td>
     *         <td>√</td>
     *         <td>√</td>
     *         <td>X</td>
     *         <td>X</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">count</td>
     *         <td>number</td>
     *         <td>允许用户选择图片的最大数，默认为9</td>
     *         <td>大客户端 vid: 80011102+<br/>独立客户端 HytiveLib: 1.1.1+</td>
     *         <td>大客户端browser vid: 27+</td>
     *         <td>X</td>
     *         <td>√</td>
     *     </tr>
     *     <tr>
     *         <td rowspan="2">thumbnail</td>
     *         <td>maxPixel</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>缩略图长宽最大尺寸，<br/>可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为原图、1200、800、400</td>
     *         <td>新大客户端、独立客户端 HytiveLib: 1.3.0+</td>
     *         <td>大客户端browser vid: 29+</td>
     *         <td>X</td>
     *         <td>X</td>
     *     </tr>
     *     <tr>
     *         <td>quality</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>缩略图JPG压缩参数，尺寸不变。<br/>为1-100之间的整数。<br/>也可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为100、90、70、50</td>
     *         <td>独立客户端 HytiveLib: 1.3.0+</td>
     *         <td>大客户端browser vid: 29+</td>
     *         <td>X</td>
     *         <td>X</td>
     *     </tr>
     * </table>
     *
     * 返回字段说明：
     *
     * | 返回字段 | 类型 | 说明 | IOS | Android | touch | wechat |
     * | :----: | :---: | :---: | :---: | :----: | :-----: | :-----: |
     * | localIds | string array | 返回选定照片的本地ID列表<br/>localId可为img标签的src属性 | √ | √ | X | √ |
     * | thumbnails | string array | 只有请求中设置了thumbnail参数才会返回<br/>返回选定照片的本地缩略图ID列表<br/>thumbnail可为img标签的src属性 | 新大客户端、独立客户端 HytiveLib: 1.3.0+ | 大客户端browser vid: 29+ | X | X |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    chooseImage: {
        hy: {
            key: 'chooseImage'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    //TODO 是否还支持缩略图 thumbnails
                    localIds: ret.localIds
                };
            }
        }
    },
    /**
     * 拍照或从手机相册中选取图片<br />
     * 新版 chooseImage，推荐使用该 API 替换 hysdk.chooseImage <br/>
     * 对应native接口：chooseImage.v1
     * @method hysdk.selectImage
     * @category Image
     * @example ./selectImage.js[1-37]
     * @description
     *
     * <table style="text-align:center">
     *     <tr>
     *         <th colspan="2">参数</th>
     *         <th>类型</th>
     *         <th>说明</th>
     *         <th>iOS</th>
     *         <th>Android</th>
     *         <th>touch</th>
     *         <th>wechat</th>
     *     </tr>
     *     <tr>
     *         <td colspan="2">sizeType</td>
     *         <td>string array</td>
     *         <td>指定原图还是压缩图，默认二者都有</td>
     *         <td rowspan="2">X</td>
     *         <td rowspan="2">X</td>
     *         <td rowspan="2">X</td>
     *         <td rowspan="2">√</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">sourceType</td>
     *         <td>string array</td>
     *         <td>指定来源是相册还是相机，默认二者都有</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">localIds</td>
     *         <td>string array</td>
     *         <td>上次已经选择过的图片<br/>从15年10月iOS新架构发布以后<br/>由于iOS公共相册组件存在bug，iOS暂时不支持使用</td>
     *         <td>X</td>
     *         <td>√</td>
     *         <td>X</td>
     *         <td>√</td>
     *     </tr>
     *     <tr>
     *         <td colspan="2">count</td>
     *         <td>number</td>
     *         <td>允许用户选择图片的最大数，默认为9</td>
     *         <td>大客户端 vid: 80011102+<br/>独立客户端 HytiveLib: 1.1.1+</td>
     *         <td>大客户端browser vid: 27+</td>
     *         <td>X</td>
     *         <td>√</td>
     *     </tr>
     *     <tr>
     *         <td rowspan="2">thumbnail</td>
     *         <td>maxPixel</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>缩略图长宽最大尺寸，<br/>可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为原图、1200、800、400</td>
     *         <td>新大客户端、独立客户端 HytiveLib: 1.3.0+</td>
     *         <td>大客户端browser vid: 29+</td>
     *         <td>X</td>
     *         <td>X</td>
     *     </tr>
     *     <tr>
     *         <td>quality</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>缩略图JPG压缩参数，尺寸不变。<br/>为1-100之间的整数。<br/>也可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为100、90、70、50</td>
     *         <td>独立客户端 HytiveLib: 1.3.0+</td>
     *         <td>大客户端browser vid: 29+</td>
     *         <td>X</td>
     *         <td>X</td>
     *     </tr>
     * </table>
     *
     * 返回字段说明：
     *
     * | 返回字段 | 类型 | 说明 | IOS | Android | touch | wechat |
     * | :----: | :---: | :---: | :---: | :----: | :-----: | :-----: |
     * | localIds | array | 只有**微信**有该参数，返回选定照片的本地ID列表<br/>localId可为img标签的src属性 | X | X | X | √ |
     * | localImgs | array | 对象数组，每个对象元素包括照片ID和拍摄角度，例如：[{ angle: 0, id: "//imghy/storage/emulated/0/Pictures/xxx/3.png"}, ...] | √ | √ | X | X |
     * | thumbnails | string array | 只有请求中设置了thumbnail参数才会返回<br/>返回选定照片的本地缩略图ID列表<br/>thumbnail可为img标签的src属性 | 新大客户端、独立客户端 HytiveLib: 1.3.0+ | 大客户端browser vid: 29+ | X | X |
     *
     * 注意：该接口 hysdk 1.2.7 及以上版本支持，iOS X.X.X 及以上版本、Android X.X.X 及以上版本支持
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    selectImage: {
        hy: {
            key: 'chooseImage.v1'
        },
        wechat: {
            key: 'chooseImage',
            successHandle: function successHandle(ret) {
                return {
                    //TODO 是否还支持缩略图 thumbnails
                    localIds: ret.localIds
                };
            }
        }
    },
    /**
     * 上传图片 <br />
     * 对应native接口：uploadImage.v1
     * @method hysdk.uploadImage
     * @category Image
     * @example ./uploadImage.js[1-30]
     * @description
     *
     * 请求参数说明：
     * <table style="text-align:center">
     *     <tr>
     *          <th width="120">参数</th>
     *          <th width="80">类型</th>
     *          <th width="220">说明</th>
     *          <th width="80">iOS</th>
     *          <th width="80">Android</th>
     *          <th width="80">touch</th>
     *          <th width="80">wechat</th>
     *      </tr>
     *      <tr>
     *          <td>localId</td>
     *          <td>string</td>
     *          <td>需要上传的图片的本地ID，由chooseImage接口获得，与 localIds 二选一，localId 上传一张图片</td>
     *          <td rowspan="7">√</td>
     *          <td rowspan="7">√</td>
     *          <td rowspan="7">X</td>
     *          <td rowspan="7">X</td>
     *      </tr>
     *      <tr>
     *          <td>localIds</td>
     *          <td>Array</td>
     *          <td>需要上传的图片的本地ID，由chooseImage接口获得，与 localId 二选一，localIds 上传多张图片，前端控制的队列上传，多次调用桥（仅 hy 支持, hysdk 1.2.2 及以上版本支持）</td>
     *      </tr>
     *      <tr>
     *          <td>serverAddress</td>
     *          <td>string</td>
     *          <td>上传服务地址。必须是在qunar域下。当不指定协议时，会根据当前页面的协议自动补齐。<br/>
     *          例如当前页面是 http 协议，serverAddress 值是 '//www.qunar.com'，自动补齐为 'http://www.qunar.com'，若指定则指定的优先级最高（自动补齐协议仅 Hy 支持，hysdk 1.2.4 及以上版本支持）</td>
     *      </tr>
     *     <tr>
     *         <td>serverParams</td>
     *         <td>map</td>
     *         <td>post到服务器的参数map（可选）</td>
     *     </tr>
     *     <tr>
     *         <td>fileKey</td>
     *         <td>string</td>
     *         <td>服务器端接口中文件对应的参数名<br/>（可选，默认值为"file"）</td>
     *     </tr>
     *     <tr>
     *         <td>maxPixel</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>上传图片长宽最大尺寸，<br/>可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为原图、1200、800、400</td>
     *     </tr>
     *     <tr>
     *         <td>quality</td>
     *         <td>number<br/>或者<br/>string</td>
     *         <td>上传图片JPG压缩参数，尺寸不变。<br/>为1-100之间的整数。<br/>也可以使用'original'、'high'、'middle'、'low'<br/>按预设品质压缩<br/>分别对应为100、90、70、50</td>
     *     </tr>
     * </table>
     *
     * 上传单张图片返回字段说明：
     *
     * | 返回字段 | 类型 | 说明 | IOS | Android | touch | wechat |
     * | :-----: | :-----: | :-----: | :-----: | :-----: | :-----: | :-----: |
     * | responseData | string | 服务器返回的数据 | √ | √ | X | X(object) |
     *
     * 上传多张图片返回字段说明：
     *
     * | 返回字段 | 类型 | 说明 | IOS | Android | touch | wechat |
     * | :-----: | :-----: | :-----: | :-----: | :-----: | :-----: | :-----: |
     * | data | Array | 服务器返回的数据（每个元素与上传单张返回的数据结构一致） | √ | √ | X | X(object) |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    uploadImage: {
        hy: {
            key: 'uploadImage.v1',
            optHandle: function optHandle(opt) {
                if (opt && opt.serverAddress) {
                    opt.serverAddress = protocol(opt.serverAddress);
                }
                return opt;
            }
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    serverId: ret.serverId
                };
            }
        }
    },
    /**
     * 预览图片<br />
     * 对应native接口：previewImage
     * @method hysdk.previewImage
     * @category Image
     * @example ./previewImage.js[1-6]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | current | String | 当前显示的图片链接 | √ | 常用参数，仅微信支持 |
     * | urls | Array | 需要预览的图片链接列表 | √ | 常用参数，仅微信支持 |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    previewImage: {
        hy: {
            key: 'previewImage'
        },
        wechat: {
            key: 'previewImage'
        }
    },
    /**
     * 下载图片<br />
     * 对应native接口：downloadImage
     * @method hysdk.downloadImage
     * @category Image
     * @example ./downloadImage.js[1-12]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | serverId | String | 需要下载的图片的服务器端ID，由uploadImage接口获得 | √ | 常用参数，仅微信支持 |
     * | isShowProgressTips | Number | 显示进度提示 | √ | 常用参数，仅微信支持 |
     * | success | Function | success 回调 | X | 常用参数，仅微信支持，可获取图片下载后的本地ID
     * | fail | Function | fail 回调 | X | 常用参数，仅微信支持
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    downloadImage: {
        hy: {
            key: 'downloadImage'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    localId: ret.localId
                };
            }
        }
    },
    /**
     * 转换图片路径<br />
     * 对应native接口：image.convertPath
     * @method hysdk.convertPath
     * @category Image
     * @example ./convertPath.js[1-18]
     * @description
     *
     * <table style="text-align:center">
     *     <tr>
     *         <th>参数</th>
     *         <th colspan="2">类型</th>
     *         <th>描述</th>
     *         <th>必选</th>
     *         <th>注明</th>
     *     </tr>
     *     <tr>
     *         <td>path</td>
     *         <td colspan="2">String</td>
     *         <td>本地图片路径</td>
     *         <td>√</td>
     *         <td>常用参数</td>
     *     </tr>
     *     <tr>
     *         <td rowspan="2">thumbnail</td>
     *         <td rowspan="2">Object</td>
     *         <td>maxPixel</td>
     *         <td>图片的长、宽最大像素尺寸</td>
     *         <td>X</td>
     *         <td>iOS支持数字或字符串，Android仅支持数字，可以使用'original'、'high'、'middle'、'low'按预设品质压缩，分别对应为原图、1200、800、400</td>
     *     </tr>
     *     <tr>
     *         <td>quality</td>
     *         <td>JPG压缩参数</td>
     *         <td>X</td>
     *         <td>支持数字或字符串，不改变图片尺寸。为1-100之间的整数。可以使用'original'、'high'、'middle'、'low'按预设品质压缩，分别对应为100、90、70、50</td>
     *     </tr>
     *     <tr>
     *         <td>success</td>
     *         <td colspan="2">Function</td>
     *         <td>成功回调</td>
     *         <td>X</td>
     *         <td>常用参数</td>
     *     </tr>
     *     <tr>
     *         <td>fail</td>
     *         <td colspan="2">Function</td>
     *         <td>失败回调</td>
     *         <td>X</td>
     *         <td>常用参数</td>
     *     </tr>
     * </table>
     * 注意：该接口 hysdk 1.2.5 及以上版本支持，iOS 4.10.16 及以上版本、Android 8.6.2 及以上版本支持
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    convertPath: {
        hy: {
            key: 'image.convertPath'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/image.js
// module id = 16
// module chunks = 0 2 4